import React from "react";
import { Typography, TypographyProps, SxProps, Theme } from "@mui/material";
import { applyGradientText } from "../../constants/gradient";

type HeadingGradientProps = TypographyProps & {
  children: React.ReactNode;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  sx?: SxProps<Theme>;
};

/**
 * Reusable Heading component with gradient text styling
 * Commonly used for section headings and titles
 */
const HeadingGradient: React.FC<HeadingGradientProps> = ({
  children,
  variant = "h2",
  sx,
  ...props
}) => {
  return (
    <Typography
      variant={variant}
      {...props}
      sx={[
        (theme) => ({
          ...applyGradientText(theme),
          fontWeight: 700,
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Typography>
  );
};

export default HeadingGradient;

